module.exports = __webpack_public_path__ + "img/certif-3.9208ced9.png";